<template>
  <div class="mian">
    <div class="nav">
      <van-nav-bar
        title="智能导诊"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
      <div class="top"></div>
    </div>
    <div class="choose_body">
      <div class="choose_cell">
        <div>年龄：</div>
        <div class="choose_cell_radio">
          <van-radio-group v-model="ageradio" direction="horizontal">
            <van-radio name="2">成人</van-radio>
            <van-radio name="1">儿童</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="choose_cell" style="margin-top: 2vh">
        <div>性别：</div>
        <div class="choose_cell_radio">
          <van-radio-group v-model="sexradio" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="querybtn">
        <van-button type="info" block @click="gobodylist()">查询</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import swtich from "./components/swtich";
export default {
  data() {
    return {
      imgname: "MMZ",
      active: 0,
      tabfalg: true,
      listfalg: false,
      sexradio: "",
      ageradio: "",
      // bg_img: {
      //   height: "90vh",
      //   width: "100%",
      //   backgroundImage:
      //     "url(" + require("../../assets/Guidance/MMZ.png") + ")",
      // },
    };
  },
  components: {
    Nav,
    swtich,
  },
  methods: {
    gobodylist() {
      console.log(this.sexradio, this.ageradio);
      if (!this.sexradio) {
        this.$toast.fail("请选择性别");
        return;
      }
      if (!this.ageradio) {
        this.$toast.fail("请选择年龄段");
        return;
      }
      this.$router.push({
        path: "/Guidance_a",
        query: {
          sex: this.sexradio,
          age: this.ageradio,
        },
      });
    },

    onClickLeft() {
      this.$router.push("/index");
    },
  },
};
</script>

<style lang="scss" scoped>
.mian {
  display: flex;
  flex-direction: column;
  max-width: 100vh;
  height: 100vh;
  background: #eee;

  .nav {
    .top {
      height: 1vh;
    }
  }
  .choose_body {
    height: 80vh;
    width: 100%;
    .choose_cell {
      display: flex;
      flex-direction: row;
      width: 95vw;
      margin: 0 auto;
      line-height: 8vh;
      height: 8vh;
      justify-content: space-between;
      border: 1px solid #f7f8fa;
      background-color: white;
      padding: 0 2vw;
      color: #333;
      .choose_cell_radio {
        margin-top: 3vh;
      }
    }
  }
  .querybtn {
    width: 95vw;
    margin: 0 auto;
    margin-top: 3vh;
  }
}
</style>